import { render, staticRenderFns } from "./ModalOtherBranch.vue?vue&type=template&id=a6a2123a&scoped=true"
import script from "./ModalOtherBranch.vue?vue&type=script&lang=js"
export * from "./ModalOtherBranch.vue?vue&type=script&lang=js"
import style0 from "./ModalOtherBranch.vue?vue&type=style&index=0&id=a6a2123a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a2123a",
  null
  
)

export default component.exports